import { cx } from '@/lib/cx'

/**
 * The clinic's own mark, on the ground it needs to stay legible.
 *
 * Four places draw this lockup — the rail, the top bar, and both halves of the
 * sign-in screen — and they were four copies of the same tile before, which is
 * how the dashboard rows drifted. One component, so a change lands everywhere.
 *
 * The plate is not decoration. The mark is two teals and the darker one is
 * `#0b4f51`: on the dark surface, and on the navy sign-in panel, that half of
 * it disappears and the logo reads as a broken shape. `--color-logo-plate` is
 * white in both themes for exactly this reason — a brand mark does not get to
 * be re-coloured by a theme, so it brings its own ground with it.
 *
 * `alt=""`: every one of these sits beside the clinic's name in text, or inside
 * a link that is already labelled. Naming it again would make a screen reader
 * say it twice.
 */
export function ClinicMark({ className }: { className?: string }) {
  return (
    <span
      className={cx(
        'grid flex-none place-items-center overflow-hidden rounded-md bg-logo-plate p-1',
        className,
      )}
    >
      <img src="/clinic-mark.png" alt="" className="size-full object-contain" />
    </span>
  )
}
